import { Theme_getDefaultTheme } from 'utils/theme'
import { createDefaultInfoPage } from './resuable'

/** Fallback data-theme when no preset; used across RootLayout, generateThemeStyles, Providers. */
export const DEFAULT_DATA_THEME = 'disporty-blue'

/** Default domain config when DB has no match (white-label fallback). */
const DISPORTY_CONFIG: IDomainConfig = {
    site_name: 'DISPORTY',
    support_mail: '',
    ads_enabled: false,
    youtube: '',
    twitter: '',
    discord: '',
    facebook: '',
    twitch: '',
    default_banner: '',
    federation_banner: '',
    organisation_id: '',
    instagram: '',
    auth_image: '',
    background_image: '',
    theme: {
        ...Theme_getDefaultTheme()
    },
    logo_size: {
        sm: {
            width: 70,
            height: 35
        },
        md: {
            width: 70,
            height: 35
        }
    },
    site_favicon: '',
    sponsors: [],
    organisation_logo: '/images/logos/disporty-logo.png',
    player_card: '',
    info_page: [
        createDefaultInfoPage(1, 'HOME', 'Default'),
        createDefaultInfoPage(2, 'HOME', 'Default'),
        createDefaultInfoPage(3, 'HOME', 'Default'),
        createDefaultInfoPage(4, 'HOME', 'Default'),
        createDefaultInfoPage(5, 'HOME', 'Default'),
        createDefaultInfoPage(6, 'ABOUT', 'Default'),
        createDefaultInfoPage(7, 'ABOUT', 'Default')
    ]
}

export default DISPORTY_CONFIG
